import { render } from "./EmptyAsset.vue?vue&type=template&id=10020b11&scoped=true&ts=true"
import script from "./EmptyAsset.vue?vue&type=script&lang=ts"
export * from "./EmptyAsset.vue?vue&type=script&lang=ts"

import "./EmptyAsset.vue?vue&type=style&index=0&id=10020b11&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10020b11"]])

export default __exports__